import { SvgType } from '../../type/svg';
import { COLOR } from '../../constant/color';

const QuestionIcon = ({ width, height, color }: SvgType) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx={13.5} cy={13.5} r={13} fill="#fff" stroke="#BABABA" />
    <path
      d="M12.555 16.82c0-.866.107-1.556.322-2.07.215-.514.638-1.078 1.27-1.69.637-.618 1.041-1.057 1.21-1.318.26-.397.391-.827.391-1.289 0-.612-.153-1.077-.459-1.396-.3-.326-.742-.489-1.328-.489-.56 0-1.012.16-1.357.479-.339.312-.508.739-.508 1.28H9.723c.013-1.153.403-2.065 1.171-2.735.775-.67 1.797-1.006 3.067-1.006 1.309 0 2.327.332 3.057.996.735.664 1.103 1.592 1.103 2.783 0 1.061-.495 2.106-1.484 3.135l-1.202 1.182c-.43.488-.65 1.2-.664 2.138h-2.216Zm-.166 3.037c0-.384.12-.693.361-.927.24-.241.566-.362.977-.362.416 0 .745.124.986.371.24.241.361.547.361.918 0 .358-.117.658-.351.899-.235.24-.567.361-.996.361-.43 0-.762-.12-.997-.361a1.257 1.257 0 0 1-.341-.899Z"
      fill={color ?? COLOR.GREY_2}
    />
  </svg>
);

export default QuestionIcon;
